import { Component } from '@angular/core';
import { MessageComponent } from 'src/app/shared/components/message/message.component';

@Component({
  selector: 'app-authorization-error',
  templateUrl: './authorization-error.component.html',
  styleUrl: './authorization-error.component.scss',
  imports: [MessageComponent],
})
export class AuthorizationErrorComponent {}
